// import React, {useState, useEffect} from 'react';
// import {List, ListItem, ListItemText, Divider} from '@mui/material';
// import Collapse from '@mui/material/Collapse';
// import ExpandLess from '@mui/icons-material/ExpandLess';
// import ExpandMore from '@mui/icons-material/ExpandMore';
// import {Link} from 'react-router-dom';
// import {EvaluarPermiso} from '../../Genericos/Generales';

// const Cobranzas = props => {
//   const classes = props.classes;
//   const sesionUsuario = props.sesionUsuario;

//   const [gestionCobranzas, setGestionCobranzas] = useState(false);
//   const [panelFacturasPropias, setPanelFacturasPropias] = useState(false);
//     const [panelFacturasResumen, setPanelFacturasResumen] = useState(false);
//     const [
//         panelPosiblesCobrosPrincipal,
//         setPanelPosiblesCobrosPrincipal,
//       ] = useState(false);
//       const [cobranzasAsignadas, setCobranzasAsignadas] = useState(false);
//       const [darDeBajaFacturas, setDarDeBajaFacturas] = useState(false);
//       const [
//         panelFacturasPendientesDeBaja,
//         setPanelFacturasPendientesDeBaja,
//       ] = useState(false);

//   useEffect (() => {
//     VerificarPermisos (
//       sesionUsuario.usuario.pantallasUsuario.listaPantallasRol
//     );
//   }, [sesionUsuario]);

//   const VerificarPermisos = arrPermisos => {
//     setPanelPosiblesCobrosPrincipal(
//         EvaluarPermiso(arrPermisos, '/panelPosiblesCobrosPrincipal')
//       );
//       setGestionCobranzas(EvaluarPermiso(arrPermisos, '/gestionCobranzas'));
//       setPanelFacturasResumen(
//         EvaluarPermiso(arrPermisos, '/panelFacturasResumen')
//       );
//       setPanelFacturasPropias(
//         EvaluarPermiso(arrPermisos, '/panelFacturasPropias')
//       );
//       setPanelFacturasPendientesDeBaja(
//         EvaluarPermiso(arrPermisos, '/panelFacturasPendientesDeBaja')
//       );
//       setCobranzasAsignadas(EvaluarPermiso(arrPermisos, '/cobranzasAsignadas'));
//       setDarDeBajaFacturas(EvaluarPermiso(arrPermisos, '/darDeBajaFacturas'));
//   };

//   const [openGestionCobranzas, setOpenGestionCobranzas] = useState(false);
//   const handleOpenGestionCobranzas = () => {
//     setOpenGestionCobranzas(!openGestionCobranzas);
//   };

//   return (
//     <React.Fragment>
//         {gestionCobranzas ? (
//         <List>
//           <ListItem onClick={handleOpenGestionCobranzas}>
//             <i notranslate="true" className="material-icons">
//               next_week
//             </i>
//             <ListItemText
//               classes={{ primary: classes.listItemText }}
//               primary="Gestión de Cobranzas"
//             />
//             {openGestionCobranzas ? <ExpandLess /> : <ExpandMore />}
//           </ListItem>
//           <Collapse in={openGestionCobranzas} timeout="auto" unmountOnExit>
//             <List component="div" disablePadding>
//               {panelFacturasPropias ? (
//                 <ListItem
//                   component={Link}
//                   button
//                   to="/panelFacturasPropias"
//                   className={classes.listItemText}
//                 >
//                   <i notranslate="true" className="material-icons">
//                     receipt
//                   </i>
//                   <ListItemText primary="Mis Facturas" />
//                 </ListItem>
//               ) : null}
//               {panelFacturasResumen ? (
//                 <ListItem
//                   component={Link}
//                   button
//                   to="/panelFacturasResumen"
//                   className={classes.listItemText}
//                 >
//                   <i notranslate="true" className="material-icons">
//                     request_quote
//                   </i>
//                   <ListItemText primary="Estado de Facturas a cobrar" />
//                 </ListItem>
//               ) : null}
//               {panelPosiblesCobrosPrincipal ? (
//                 <ListItem
//                   component={Link}
//                   button
//                   to="/panelPosiblesCobrosPrincipal"
//                   className={classes.listItemText}
//                 >
//                   <i notranslate="true" className="material-icons">
//                     attach_money
//                   </i>
//                   <ListItemText primary="Posibles Cobros" />
//                 </ListItem>
//               ) : null}
//               {cobranzasAsignadas ? (
//                 <ListItem
//                   component={Link}
//                   button
//                   to="/cobranzasAsignadas"
//                   className={classes.listItemText}
//                 >
//                   <i notranslate="true" className="material-icons">
//                     near_me
//                   </i>
//                   <ListItemText primary="Mis Cobros" />
//                 </ListItem>
//               ) : null}
//               {darDeBajaFacturas ? (
//                 <ListItem
//                   component={Link}
//                   button
//                   to="/darDeBajaFacturas"
//                   className={classes.listItemText}
//                 >
//                   <i notranslate="true" className="material-icons">
//                     point_of_sale
//                   </i>
//                   <ListItemText primary="Dar de Baja Facturas" />
//                 </ListItem>
//               ) : null}
//               {panelFacturasPendientesDeBaja ? (
//                 <ListItem
//                   component={Link}
//                   button
//                   to="/panelFacturasPendientesDeBaja"
//                   className={classes.listItemText}
//                 >
//                   <i notranslate="true" className="material-icons">
//                     local_atm
//                   </i>
//                   <ListItemText primary="Facturas Pendientes de Baja" />
//                 </ListItem>
//               ) : null}
//             </List>
//           </Collapse>
//         </List>
//       ) : null}

//       {gestionCobranzas ? <Divider /> : null}
//     </React.Fragment>)
//   }

//   export default Cobranzas
import React, { useState, useEffect } from 'react';
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Collapse,
} from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import DescriptionIcon from '@mui/icons-material/Description';
import ReceiptIcon from '@mui/icons-material/Receipt';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import NearMeIcon from '@mui/icons-material/NearMe';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import { Link } from 'react-router-dom';
import { EvaluarPermiso } from '../../Genericos/Generales';
import { menuItemStyles } from '../../Tools/MenuItemStyles';

const Cobranzas = ({ sesionUsuario }) => {
  const [gestionCobranzas, setGestionCobranzas] = useState(false);
  const [panelFacturasPropias, setPanelFacturasPropias] = useState(false);
  const [panelFacturasResumen, setPanelFacturasResumen] = useState(false);
  const [panelPosiblesCobrosPrincipal, setPanelPosiblesCobrosPrincipal] = useState(false);
  const [cobranzasAsignadas, setCobranzasAsignadas] = useState(false);
  const [darDeBajaFacturas, setDarDeBajaFacturas] = useState(false);
  const [panelFacturasPendientesDeBaja, setPanelFacturasPendientesDeBaja] = useState(false);
  const [panelFacturasGeneral, setPanelFacturasGeneral] = useState(false);

  const [openGestionCobranzas, setOpenGestionCobranzas] = useState(false);
  const handleOpenGestionCobranzas = () => {
    setOpenGestionCobranzas(!openGestionCobranzas);
  };
  
  useEffect(() => {
    const permisos = sesionUsuario.usuario.pantallasUsuario.listaPantallasRol;
    setGestionCobranzas(EvaluarPermiso(permisos, '/gestionCobranzas'));
    setPanelFacturasPropias(EvaluarPermiso(permisos, '/panelFacturasPropias'));
    setPanelFacturasResumen(EvaluarPermiso(permisos, '/panelFacturasResumen'));
    setPanelPosiblesCobrosPrincipal(EvaluarPermiso(permisos, '/panelPosiblesCobrosPrincipal'));
    setCobranzasAsignadas(EvaluarPermiso(permisos, '/cobranzasAsignadas'));
    setDarDeBajaFacturas(EvaluarPermiso(permisos, '/darDeBajaFacturas'));
    setPanelFacturasPendientesDeBaja(EvaluarPermiso(permisos, '/panelFacturasPendientesDeBaja'));
    setPanelFacturasGeneral(EvaluarPermiso(permisos, '/panelFacturasGeneral'));
  }, [sesionUsuario]);

  return (
    <>
      {gestionCobranzas && (
        <>
          <ListItem
            button
            onClick={handleOpenGestionCobranzas}
            sx={menuItemStyles.expandableHeader}
          >
            <ListItemIcon sx={menuItemStyles.menuIcon}>
              <AccountBalanceWalletIcon />
            </ListItemIcon>
            <ListItemText
              primary="Gestión de Cobranzas"
              sx={menuItemStyles.menuText}
            />
            {openGestionCobranzas ? <ExpandLess /> : <ExpandMore />}
          </ListItem>

          <Collapse in={openGestionCobranzas} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {panelFacturasGeneral && (
                <ListItem
                  button
                  component={Link}
                  to="/panelFacturasGeneral"
                  sx={menuItemStyles.subMenuItem}
                >
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <DescriptionIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Panel General de Facturas"
                    sx={menuItemStyles.subMenuText}
                  />
                </ListItem>
              )}

              {panelFacturasPropias && (
                <ListItem
                  button
                  component={Link}
                  to="/panelFacturasPropias"
                  sx={menuItemStyles.subMenuItem}
                >
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <ReceiptIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Mis Facturas"
                    sx={menuItemStyles.subMenuText}
                  />
                </ListItem>
              )}

              {panelFacturasResumen && (
                <ListItem
                  button
                  component={Link}
                  to="/panelFacturasResumen"
                  sx={menuItemStyles.subMenuItem}
                >
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <RequestQuoteIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Estado de Facturas a cobrar"
                    sx={menuItemStyles.subMenuText}
                  />
                </ListItem>
              )}

              {panelPosiblesCobrosPrincipal && (
                <ListItem
                  button
                  component={Link}
                  to="/panelPosiblesCobrosPrincipal"
                  sx={menuItemStyles.subMenuItem}
                >
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <AttachMoneyIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Posibles Cobros"
                    sx={menuItemStyles.subMenuText}
                  />
                </ListItem>
              )}

              {cobranzasAsignadas && (
                <ListItem
                  button
                  component={Link}
                  to="/cobranzasAsignadas"
                  sx={menuItemStyles.subMenuItem}
                >
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <NearMeIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Mis Cobros"
                    sx={menuItemStyles.subMenuText}
                  />
                </ListItem>
              )}

              {darDeBajaFacturas && (
                <ListItem
                  button
                  component={Link}
                  to="/darDeBajaFacturas"
                  sx={menuItemStyles.subMenuItem}
                >
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <PointOfSaleIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Dar de Baja Facturas"
                    sx={menuItemStyles.subMenuText}
                  />
                </ListItem>
              )}

              {panelFacturasPendientesDeBaja && (
                <ListItem
                  button
                  component={Link}
                  to="/panelFacturasPendientesDeBaja"
                  sx={menuItemStyles.subMenuItem}
                >
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <LocalAtmIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Facturas Pendientes de Baja"
                    sx={menuItemStyles.subMenuText}
                  />
                </ListItem>
              )}
            </List>
          </Collapse>
        </>
      )}
    </>
  );
};

export default Cobranzas;
